import { render, staticRenderFns } from "./Payment.vue?vue&type=template&id=5b236415&scoped=true&style=background-color%3Ablack%3B&"
import script from "./Payment.vue?vue&type=script&lang=js&"
export * from "./Payment.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5b236415",
  null
  
)

export default component.exports